/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import ProductsMaintenanceList from './ProductsMaintenanceList.js';
import requestConnector from './requestConnector.js';
import bucketedListConnector from './bucketedListConnector.js';
import { withRouter } from 'react-router-dom';
import { withRequests } from '../../../higherOrderComponents/requests';

export default withRouter(requestConnector(bucketedListConnector(ProductsMaintenanceList)));
